export default "__VITE_ASSET__CQJrfNjK__"